export default class FormModule {
  constructor() {
    this.init();
  }

  init() {
    this.checkInputValues();
    this.focusFirstError();
  }

  focusFirstError() {
    const formWrapper = document.querySelector('.form-module__gravity-form');
    if (!formWrapper) return;

    const focusFirst = () => {
      const firstErrorField = formWrapper.querySelector('.gfield_error');
      if (!firstErrorField) return;

      const firstInput = firstErrorField.querySelector(
        'input[type="text"], input[type="email"], input[type="number"], input[type="tel"], input[type="url"], textarea, select',
      );
      if (firstInput) {
        firstInput.focus({ preventScroll: true });
      }
    };

    // AJAX form: GF replaces DOM then triggers gform_page_loaded
    jQuery(document).on('gform_page_loaded', () => {
      // Delay slightly to let GF finish its own scroll (50ms) before focusing
      setTimeout(focusFirst, 100);
    });

    // Non-AJAX fallback: check on initial page load
    focusFirst();
  }

  /**
   * Check all form inputs for values and add .has-value class to parent .gfield
   */
  checkInputValues() {
    const formWrapper = document.querySelector('.form-module__gravity-form');
    if (!formWrapper) return;

    // Get all input elements (text, email, number, etc.)
    const textInputs = formWrapper.querySelectorAll('input[type="text"], input[type="email"], input[type="number"], input[type="tel"], input[type="url"]');

    // Get all textareas
    const textareas = formWrapper.querySelectorAll('textarea');

    // Get all select elements
    const selects = formWrapper.querySelectorAll('select');

    // Get all checkboxes and radio buttons
    const checkboxes = formWrapper.querySelectorAll('input[type="checkbox"]');
    const radios = formWrapper.querySelectorAll('input[type="radio"]');

    // Helper function to find parent .gfield
    const findParentGfield = (element) => {
      return element.closest('.gfield');
    };

    // Helper function to check and update has-value class
    const updateHasValueClass = (input) => {
      const gfield = findParentGfield(input);
      if (!gfield) return;

      if (input.value && input.value.trim() !== '') {
        gfield.classList.add('has-value');
      } else {
        gfield.classList.remove('has-value');
      }
    };

    // Helper function for select elements (check if not placeholder)
    const updateSelectHasValueClass = (select) => {
      const gfield = findParentGfield(select);
      if (!gfield) return;

      const selectedOption = select.options[select.selectedIndex];
      const isPlaceholder = selectedOption && selectedOption.classList.contains('gf_placeholder');

      if (select.value && select.value.trim() !== '' && !isPlaceholder) {
        gfield.classList.add('has-value');
      } else {
        gfield.classList.remove('has-value');
      }
    };

    // Helper function for checkboxes/radios (check if any in the group is checked)
    const updateCheckboxRadioHasValueClass = (input) => {
      const gfield = findParentGfield(input);
      if (!gfield) return;

      // For checkboxes and radios, check if any input in the gfield is checked
      const allInputsInField = gfield.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      const hasChecked = Array.from(allInputsInField).some(inp => inp.checked);

      if (hasChecked) {
        gfield.classList.add('has-value');
      } else {
        gfield.classList.remove('has-value');
      }
    };

    // Process text inputs and textareas
    [...textInputs, ...textareas].forEach(input => {
      // Check initial value
      updateHasValueClass(input);

      // Add event listeners for dynamic updates
      input.addEventListener('input', () => updateHasValueClass(input));
      input.addEventListener('change', () => updateHasValueClass(input));
    });

    // Process select elements
    // selects.forEach(select => {
    //   // Check initial value
    //   updateSelectHasValueClass(select);

    //   // Add event listener for changes
    //   select.addEventListener('change', () => updateSelectHasValueClass(select));
    // });

    // // Process checkboxes
    // checkboxes.forEach(checkbox => {
    //   // Check initial state
    //   updateCheckboxRadioHasValueClass(checkbox);

    //   // Add event listener for changes
    //   checkbox.addEventListener('change', () => updateCheckboxRadioHasValueClass(checkbox));
    // });

    // // Process radio buttons
    // radios.forEach(radio => {
    //   // Check initial state
    //   updateCheckboxRadioHasValueClass(radio);

    //   // Add event listener for changes
    //   radio.addEventListener('change', () => updateCheckboxRadioHasValueClass(radio));
    // });
  }
}

new FormModule();
